import { render, staticRenderFns } from "./MenuLightbox.vue?vue&type=template&id=04de29ec&scoped=true"
import script from "./MenuLightbox.vue?vue&type=script&lang=ts"
export * from "./MenuLightbox.vue?vue&type=script&lang=ts"
import style0 from "./MenuLightbox.vue?vue&type=style&index=0&id=04de29ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04de29ec",
  null
  
)

export default component.exports